import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=08c53ea7&scoped=true&"
import script from "./Background.vue?vue&type=script&lang=js&"
export * from "./Background.vue?vue&type=script&lang=js&"
import style0 from "./Background.vue?vue&type=style&index=0&id=08c53ea7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c53ea7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarousel,VCarouselItem,VImg})
